import { apiFuns } from "sw-hic";
let { get, post, put, del, genStandard } = apiFuns;
let api = {
  Staff: {
    ...genStandard("staff", "/api/md"),
    sync: (staffId, auCode) => post(`/api/md/staff/synDoctor/${staffId}/${auCode}`),
    pwd: (para) => put("/api/md/staff/password", para),
    queryRole: (id, para) => get(`/api/md/staff/${id}/role`, para),
    addRole: (id, roleCode) => post(`/api/md/staff/${id}/role/${roleCode}`),
    delRole: (id, roleCode) => del(`/api/md/staff/${id}/role/${roleCode}`),
    queryOidc: (staffId) => get(`/api/md/staff/${staffId}/oidc`),
    getOidc: (au, openId) => get(`/api/md/staff/oidc/${au}/${openId}`),
    updateOidc: (para) => put(`/api/md/staff/oidc/${para.auCode}/${para.openId}`, para),
    addOidc: (userId, para) => post(`/api/md/staff/${userId}/oidc`, para),
    getOidcImg: para => get(`/api/md/staff/oidc/signImage`, para),
  },
  Role: genStandard("role", "/api/md", true),
};
export default api;
